var content = require("!!../../../node_modules/css-loader/index.js!./bootstrap.min.css");
content = content.__esModule ? content.default : content;

if (typeof content === 'string') {
  content = [[module.id, content, '']];
}

var options = {}

options.insert = "head";
options.singleton = false;

var update = require("!../../../node_modules/style-loader/dist/runtime/injectStylesIntoStyleTag.js")(content, options);

if (content.locals) {
  module.exports = content.locals;
}



//////////////////
// WEBPACK FOOTER
// ./src/assets/css/bootstrap.min.css
// module id = 303
// module chunks = 0